import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useState, useEffect } from "react";
import Helper from 'src/support/Helper';
import { Pagination } from 'src/reusable/global';
import { useQuoteStore } from "../../hooks/quote";
import moment from "moment";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { useQuoteFilterSelectionStore } from 'src/hooks/component/quote-filter-selection';
import NoResultContent from 'src/pages/HomePageContent/NoResultContent';
import QuoteDetail from '@system/config/quote-detail';
import getSymbolFromCurrency from "currency-symbol-map/currency-symbol-map";
import Product from '@system/config/product';
import Constants from 'src/support/Constants';
import ShowMoreLess from 'src/component/Product/ShowMoreLess';
import stickyTableCommon from 'src/helper/stickyTableCommon';

// 1-feb-23 - DT - display Manufecture detail if no product exists
// 9081 - 8-feb-23 - DT - 9081 - Wrong currency displaying in quote exported file when quoted price is not available 
// 9259 - DT - 16Feb - column update - header / hide quotePRicefor nobid
// 9607 - DT - 16Feb - Provisional quote number in quotes search result

export function SubmittedQuoteFilterList() {
    const [__check] = useAxiosIndicatorCheck();
    const [{ searchQuoteList, quoteReasonList, statusList }, { fetch_search_quote_list, get_quote_reason_list }, { }] = useQuoteStore();
    const [searchParams] = useSearchParams();
    const [list, setList] = useState([]);
    const [{ filter_list }, { }, { clear_all_filter }] = useQuoteFilterSelectionStore();
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: searchParams.get("page") ? searchParams.get("page") : 1,
        limit: searchParams.get("limit") ? searchParams.get("limit") : 20,
        sortBy: 'quotelinenumber',
        sortOrder: 'ASC',
        ascDesField: {}
    });
    const setPageLimit = async (event) => {
        setListObj({ ...listObj, limit: event.target.value })
    };

    // useEffect(() => {
    //     // 11360
    //     async function fetchHere() {
    //         await get_quote_reason_list();
    //     }
    //     if (quoteReasonList && quoteReasonList?.length === 0)
    //         fetchHere();
    // }, []);

    useEffect(() => {
        async function fetchHere() {
            fetchAPICall()
        }
        if (quoteReasonList && quoteReasonList?.length > 0) {
            fetchHere();
        }
    }, [quoteReasonList, filter_list, listObj.page, listObj.limit, listObj.sortBy, listObj.sortOrder]);

    useEffect(() => {
        if (searchQuoteList && Object.keys(searchQuoteList).length > 0) {
            const data = searchQuoteList;
            const total = data.count;
            setList(searchQuoteList.records)
            setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) })
        }
    }, [searchQuoteList]);

    const fetchAPICall = async () => {
        let expDt = getFilterValue('expirationDate');
        expDt = expDt ? setDateForFilter(expDt) : expDt;

        let submissionDt = getFilterValue('submissionDate');
        submissionDt = submissionDt ? setDateForFilter(submissionDt) : submissionDt;

        await fetch_search_quote_list({
            quoteNumber: getFilterValue('quoteNumber'),
            quoteSubmissionDateFrom: submissionDt ? submissionDt[0] : '',
            quoteSubmissionDateTo: submissionDt ? submissionDt[1] : '',
            quoteExpirationDateFrom: expDt ? expDt[0] : '',
            quoteExpirationDateTo: expDt ? expDt[1] : '',
            manufacturer: getFilterValue('manufacturer'),
            manufacturerPartNumber: getFilterValue('manufacturerPartNumber'),
            customerPartNumber: getFilterValue('customerPartNumber'),
            quoteStatus: getFilterValue('status'),
            contactName: getFilterValue('contactName'),
            buyer: getFilterValue('buyer'),
            pageNumber: listObj.page,
            pageSize: listObj.limit,
            sortBy: listObj.sortBy,
            sortType: listObj.sortOrder,
            quoteReasonType: getFilterValue('quoteReasonType')
        })
    };

    const setDateForFilter = (dtObj) => {
        let _dt = dtObj.split("-");
        _dt[0] = moment(_dt[0]).local().format("YYYYMMDD");
        _dt[1] = moment(_dt[1]).local().format("YYYYMMDD");
        return _dt;
    }

    const getFilterValue = (key) => {
        if (key === 'status') {
            let keyword = filter_list.find(f => f.searchKey === key)?.searchKeywordArr;
            if (keyword) {
                let statusLst = ""
                keyword.forEach(ele => {
                    let _status = (Object.values(statusList)).find(f => f.text === ele).id;
                    statusLst = statusLst ? `${statusLst},${_status}` : `${_status}`
                });
                return statusLst;
            }
            return ""
        } else {
            let searchedVal = filter_list.find(f => f.searchKey === key)?.searchKeyword;
            if (key == 'quoteReasonType') {
                if (searchedVal) {
                    let keyword = quoteReasonList.find(f => f.quoteReasonName === searchedVal)?.quoteReasonType
                    return keyword ? keyword : searchedVal;
                } else {
                    return ""
                }
            } else {
                return searchedVal ? searchedVal : "";
            }
        }
    }

    const handlePageClick = async (data) => {
        let here_page = 0
        here_page = data.selected + 1;
        setListObj({ ...listObj, page: here_page })
        Helper.scrollTop();
    };

    const toggleOrderBy = async (columnName) => {
        if (listObj.ascDesField.hasOwnProperty(columnName)) {
            listObj.ascDesField[columnName] = listObj.ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC'
            setListObj({ ...listObj, ascDesField: listObj.ascDesField })

        } else {
            listObj.ascDesField[columnName] = 'ASC'
            setListObj({ ...listObj, ascDesField: listObj.ascDesField });

        }
        setListObj({ ...listObj, sortBy: columnName, sortOrder: listObj.ascDesField[columnName] });
    };

    const getOrderByClass = (columnName) => {
        if (listObj.sortBy === columnName && listObj.ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + listObj.ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    const onQuoteDetailRedirection = (ele, status) => {
        clear_all_filter();
        if (status === "PND") {
            window.location.href = QuoteDetail.getQuoteDetailPageRouteURL({
                quoteProvisionalNumber: ele.quoteProvisionalNumber,
                __c_QuoteDetailTabList: "PND"
            });
        } else {
            window.location.href = QuoteDetail.getQuoteDetailPageRouteURL({
                quote_number: ele.quoteNumber,
                quoteProvisionalNumber: ele.quoteProvisionalNumber
            });
        }
    }

    /**
     * Ticket #  : 10890
     * Change    : Sticky header call
     * Change by : Pankaj
     * Date      : 01 Sep,2023 
     */
    useEffect(() => {
        let callBackResult;
        if (list && list.length > 0) {
            callBackResult = stickyTableCommon('submittedquotelisting-table', toggleOrderBy)
        }
    }, [list, __check(['QUOTE_API_CALL']).status])

    return (
        <>
            {__check(['QUOTE_API_CALL']).render}
            {!__check(['QUOTE_API_CALL']).status &&
                <>
                    {list && list?.length > 0 ?
                        <>
                            <div className="tab-content p-0 mx-3">
                                <div id="tab1" className="tab-pane active table-container">
                                    <div id='sticky-table-wrapper' className="table-responsive sticky-table-wrapper">
                                        <table id='submittedquotelisting-table' className="bs5 table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Part Information</th>
                                                    <th>Web Quote Number
                                                        <span aria-label='quoteprovisionalnumber' className={'sort-container ' + getOrderByClass('quoteprovisionalnumber')} onClick={async () => { await toggleOrderBy('quoteprovisionalnumber') }}></span>
                                                    </th>
                                                    <th>Target Price
                                                        <span aria-label='targetprice' className={'sort-container ' + getOrderByClass('targetprice')} onClick={async () => { await toggleOrderBy('targetprice') }}></span>
                                                    </th>
                                                    <th>Quantity 1</th>
                                                    <th>Quantity 2</th>
                                                    <th>Quantity 3</th>
                                                    <th>Quote Reference
                                                        <span aria-label='quotereferencenumber' className={'sort-container ' + getOrderByClass('quotereferencenumber')} onClick={async () => { await toggleOrderBy('quotereferencenumber') }}></span>
                                                    </th>
                                                    <th><span>Currency</span>
                                                        <span aria-label='currency' className={'sort-container ' + getOrderByClass('currency')} onClick={async () => { await toggleOrderBy('currency') }}></span>
                                                    </th>
                                                    <th>Description</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list.map((ele, idx) => (
                                                    <tr key={idx}>
                                                        <td>
                                                            <b>Found in Quote</b>
                                                            <br />
                                                            <a href={void 0} onClick={() => { onQuoteDetailRedirection(ele) }}>{ele.quoteNumber}
                                                            </a>
                                                        </td>
                                                        <td className="partnumber-detail">
                                                            <div>
                                                                <label>Manufacturer:</label>
                                                                <span>
                                                                    {ele.manufacturerName ? ele.manufacturerName : ((ele.product && ele.product.ManufacturerName) ? ele.product.ManufacturerName : Constants.noValue)}
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <label>Mfg Part #:</label>
                                                                {/* get product url */}
                                                                <span>
                                                                    {(ele.product && ele.product.ItemNumber) ?
                                                                        <a href={Product.getProductDetailPageRouteURLWithCustomParameter(ele.product) + '?ItemNumber=' + (ele.product && ele.product.ItemNumber)}>
                                                                            {ele.product && ele.product.ERPMFRPartNumber ? ele.product.ERPMFRPartNumber : Constants.noValue}</a>
                                                                        :
                                                                        ele.mfrPartNumber
                                                                    }
                                                                </span>
                                                            </div>
                                                            {ele.customerPartNumber && ele.customerPartNumber.trim() !== "" && <div>
                                                                <label>Customer Part #:</label>
                                                                <span>{ele.customerPartNumber}</span>
                                                            </div>
                                                            }
                                                        </td>
                                                        <td>
                                                            {ele.quoteProvisionalNumber?.trim() ?
                                                                <a href={void 0} onClick={() => { onQuoteDetailRedirection(ele, "PND") }}>
                                                                    {ele.quoteProvisionalNumber}</a>
                                                                : ele.quoteSource === 'offline' ? Constants.noValue : " Pending"}
                                                        </td>
                                                        <td>{(ele.targetPrice && ele.targetPrice > 0) ? Helper.getFormatNumber(ele.targetPrice, ele.targetCurrency, true, 5) : Constants.noValue}</td>
                                                        <td>
                                                            <div>
                                                                <label>Quantity 1:</label>
                                                                <span className="red-txt"> {ele.quantity_1.quantity ? ele.quantity_1.quantity : Constants.noValue} </span>
                                                            </div>
                                                            {(ele.quoteStatus !== "No Bid" && ele.quoteStatus !== "Expired" && ele.quoteStatus !== "Pending") &&
                                                                <div>
                                                                    <label>Quoted Price: </label>
                                                                    <span> {Helper.getFormatNumber(ele.quantity_1.quotedPrice, ele.quantity_1.currency, true, 5)} </span>
                                                                </div>}
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <label>Quantity 2:</label>
                                                                <span className="red-txt"> {ele.quantity_2.quantity ? ele.quantity_2.quantity : Constants.noValue}</span>
                                                            </div>
                                                            {(ele.quantity_2.quantity && ele.quantity_2.quantity > 0 && (ele.quoteStatus !== "No Bid" && ele.quoteStatus !== "Expired")) &&
                                                                <div>
                                                                    <label>Quoted Price: </label>
                                                                    <span> {ele.quantity_2.quotedPrice ? Helper.getFormatNumber(ele.quantity_2.quotedPrice, ele.quantity_2.currency, true, 5) : ' ——'}</span>
                                                                </div>
                                                            }
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <label>Quantity 3:</label>
                                                                <span className="red-txt"> {ele.quantity_3.quantity ? ele.quantity_3.quantity : Constants.noValue}  </span>
                                                            </div>
                                                            {(ele.quantity_3.quantity && ele.quantity_3.quantity > 0 && (ele.quoteStatus !== "No Bid" && ele.quoteStatus !== "Expired")) &&
                                                                <div>
                                                                    <label>Quoted Price: </label>
                                                                    <span>{ele.quantity_3.quotedPrice ? Helper.getFormatNumber(ele.quantity_3.quotedPrice, ele.quantity_3.currency, true, 5) : Constants.noValue}</span>
                                                                </div>
                                                            }
                                                        </td>
                                                        <td>{Helper.valueIsNotNull(ele.quoteReferenceNumber) ? ele.quoteReferenceNumber : Constants.noValue}</td>
                                                        <td>{Helper.valueIsNotNull(ele.quoteCurrency) ?
                                                            <span>{getSymbolFromCurrency(ele.quoteCurrency)} {ele.quoteCurrency} </span>
                                                            : Constants.noValue}
                                                        </td>
                                                        <td>
                                                            {ele.product?.ShortDescription && ele.product?.ShortDescription !== undefined && ele.product?.ShortDescription !== null && ele.product?.ShortDescription?.trim() != '' ?
                                                                <ShowMoreLess single_product={ele.product} /> : '——'}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            {list && list?.length > 0 &&
                                <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                            }
                        </>
                        :
                        <div className='mx-3'>
                            <NoResultContent message={"Sorry! We can't find any results based on your selection"} isDisplay={false} />
                        </div>
                    }
                </>
            }
        </>
    );

}
